import React from 'react';
import {
  getCatalogProductDimensionParts,
  type ProductDimensionPart,
} from '../../utils/productDimensions';
import './ProductDimensionsStack.css';

type Props = {
  product?: Parameters<typeof getCatalogProductDimensionParts>[0];
};

// One dimension per line: muted label left, value + unit right (components/layout/DESIGN.md, multi-value cells).
const ProductDimensionsStack: React.FC<Props> = ({ product }) => {
  const parts: ProductDimensionPart[] = getCatalogProductDimensionParts(product);
  if (parts.length === 0) return <span className="product-dimensions-empty">—</span>;

  return (
    <dl className="product-dimensions">
      {parts.map((part) => (
        <React.Fragment key={part.field}>
          <dt>{part.label}</dt>
          <dd>{part.value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
};

export default ProductDimensionsStack;
